import { render, staticRenderFns } from "./friendlist.vue?vue&type=template&id=390b8b16&scoped=true&"
import script from "./friendlist.vue?vue&type=script&lang=js&"
export * from "./friendlist.vue?vue&type=script&lang=js&"
import style0 from "./friendlist.vue?vue&type=style&index=0&id=390b8b16&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b8b16",
  null
  
)

export default component.exports